import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import styled from "styled-components";

type AddTransactionsMenuProps = {
  onAddReceive(): void;
  onAddDeposit(): void;
  onAddWithdrawal(): void;
  onAddPayoutCash(): void;
  onAddBillPayment(): void;
  onAddCreditCard(): void;
  onAddTransfer(): void;
  onAddSellDraft(): void;
  onAddGLEntry(): void;
  isReadOnlyView: boolean;
  isLoading: boolean;
};

export default function AddTransactionsMenu(props: AddTransactionsMenuProps) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <MenuContainer>
      <Button
        id="basic-button"
        aria-controls="basic-menu"
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        variant="contained"
        disabled={props.isReadOnlyView || props.isLoading}
      >
        Add
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem
          onClick={() => {
            props.onAddReceive();
            handleClose();
          }}
        >
          Receive
        </MenuItem>
        <MenuItem
          onClick={() => {
            props.onAddBillPayment();
            handleClose();
          }}
        >
          Bill Payment
        </MenuItem>
        <MenuItem
          onClick={() => {
            props.onAddCreditCard();
            handleClose();
          }}
        >
          Credit Card
        </MenuItem>
        <MenuItem
          onClick={() => {
            props.onAddPayoutCash();
            handleClose();
          }}
        >
          Payout Cash
        </MenuItem>
        <MenuItem
          onClick={() => {
            props.onAddSellDraft();
            handleClose();
          }}
        >
          Sell Draft
        </MenuItem>
        <MenuItem
          onClick={() => {
            props.onAddTransfer();
            handleClose();
          }}
        >
          Transfer
        </MenuItem>
        <MenuItem
          onClick={() => {
            props.onAddDeposit();
            handleClose();
          }}
        >
          Deposit
        </MenuItem>
        <MenuItem
          onClick={() => {
            props.onAddWithdrawal();
            handleClose();
          }}
        >
          Withdrawal
        </MenuItem>
        <MenuItem
          onClick={() => {
            props.onAddGLEntry();
            handleClose();
          }}
        >
          GL Entry
        </MenuItem>
      </Menu>
    </MenuContainer>
  );
}

const MenuContainer = styled.div`
  display: flex;
  justify-content: center;
`;
